<svg [attr.width]="width" [attr.height]="height"><use [attr.xlink:href]="'assets/images/sprite.svg#' + id"></use></svg>
